import React from "react";

export default function Footer(props) {
    return <footer>Copyright &copy; {new Date().getFullYear()} Maxwell Wheeler. All Rights Reserved.</footer>;
}
